import { getBroadcastsByItemNumber } from '@moal/api'
import { useEffect, useState } from 'react'
import { PRODUCT_CODE } from '../../../utils/ENV'
import { setPageTitle } from '../../../utils/utilities'
import Tooltip from '../../Utilities/Tooltip'

const NotificationHistory = () => {
  setPageTitle('Notification History')

  const [notifications, setNotifications] = useState([])

  useEffect(() => {
    const loadNotifications = async () => {
      const response = await getBroadcastsByItemNumber({
        token: localStorage.getItem('authToken'),
        itemNumber: PRODUCT_CODE
      })
      if (response && response.data) {
        setNotifications(response.data)
      }
    }

    loadNotifications()
  }, [])

  return (
    <div className="w-full p-0 lg:p-5 lg:bg-neutral-50 lg:dark:bg-neutral-950 lg:rounded-xl">
      <div className="flex w-full flex-col gap-4">
        <div className="flex items-center">
          <h2 className="mr-3">Notification History</h2>
          <Tooltip>View notification history here.</Tooltip>
        </div>
        <div className="flex items-center">
          <h3 className="mr-3">
            The last 10 notifications triggered from this site.
          </h3>
        </div>

        <ul className="space-y-4">
          {notifications.map((notif) => (
            <Notification key={notif._id} notif={notif} />
          ))}
        </ul>
      </div>
    </div>
  )
}

const Notification = ({ notif }) => {
  const hasResults = notif.results && Object.values(notif.results).some(Boolean)

  return (
    <li className="rounded-xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-900">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <p className="text-sm font-medium dark:text-neutral-100">
            Notification
          </p>
          <p className="text-xs text-neutral-500 dark:text-neutral-400">
            {new Date(notif.createdAt).toLocaleString()}
          </p>
        </div>

        {hasResults && (
          <span className="rounded-full bg-neutral-100 px-3 py-1 text-xs font-medium text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300">
            {Object.values(notif.results).filter(Boolean).length} results
          </span>
        )}
      </div>

      {hasResults ? (
        <Results results={notif.results} />
      ) : (
        <div className="rounded-lg border border-dashed border-neutral-300 bg-neutral-50 p-4 text-center text-sm text-neutral-500 dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-400">
          No results available
        </div>
      )}
    </li>
  )
}

const formatResponse = (response) => {
  try {
    const parsed = JSON.parse(response)
    return JSON.stringify(parsed, null, 2)
  } catch {
    return response
  }
}

const Results = ({ results }) => {
  if (!results) return null

  return (
    <ul className="space-y-3">
      {Object.entries(results).map(([key, value]) => {
        if (!value) return null

        return (
          <li
            key={key}
            className="rounded-lg border border-neutral-200 bg-neutral-50 p-3 dark:border-neutral-700 dark:bg-neutral-800"
          >
            <div className="mb-2 flex items-center justify-between gap-3">
              <h3 className="text-sm font-semibold dark:text-neutral-100">
                {key}
              </h3>

              <span
                className={`rounded-full px-2.5 py-1 text-xs font-medium ${
                  value.success
                    ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200'
                    : 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200'
                }`}
              >
                {value.success ? 'Success' : 'Failed'}
              </span>
            </div>

            <pre className="max-h-48 overflow-auto rounded-md bg-neutral-950 p-3 text-xs text-neutral-100 dark:bg-neutral-950">
              {formatResponse(value.response)}
            </pre>
          </li>
        )
      })}
    </ul>
  )
}

export default NotificationHistory
